import * as actionTypes from "./actionTypes";
import axios from "../../axios-amps";
import { logFirebaseEvent } from "../../shared/utility";
import { serverconfigs } from "../../constants";

export const submitUpdatedAddressStarted = () => {
  return {
    type: actionTypes.SUBMIT_UPDATED_ADDRESS_STARTED,
  };
};
export const submitUpdatedAddressSuccess = () => {
  return {
    type: actionTypes.SUBMIT_UPDATED_ADDRESS_SUCCESS,
  };
};
export const submitUpdatedAddressFailed = (errorMessage) => {
  return {
    type: actionTypes.SUBMIT_UPDATED_ADDRESS_FAILED,
    errorMessage: errorMessage,
  };
};

export const resetUpdatedAddress = () => {
  return {
    type: actionTypes.RESET_UPDATED_ADDRESS,
  };
};

export const submitUpdatedAddress = (updatedAddress: {
  patientId: string;
  phone: string;
  email: string;
  streetAddress: string;
  city: string;
  state: string;
  postalCode: string;
}) => {
  return (dispatch) => {
    dispatch(submitUpdatedAddressStarted());
    axios
      .put(serverconfigs.submitUpdatedAddressUrl+`/`, updatedAddress)
      .then((response) => {
        console.log(response.data);
        dispatch(submitUpdatedAddressSuccess());
      })
      .catch((error) => {
        if (error.statusCode === 400) {
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            dispatch(submitUpdatedAddressFailed(error.response.data.message));
          } else {
            dispatch(submitUpdatedAddressFailed(error.message));
          }
          logFirebaseEvent("Exception400");
        } else if (error.statusCode === 401) {
          logFirebaseEvent("Exception401");
          dispatch(submitUpdatedAddressFailed(error.message));
        } else if (error.statusCode === 500) {
          logFirebaseEvent("Exception500");
          dispatch(submitUpdatedAddressFailed(error.message));
        } else dispatch(submitUpdatedAddressFailed(error.message));
      });
  };
};
